import styled from '@emotion/styled'
import { Icon } from '@okam/shared-ui'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import tw, { css } from 'twin.macro' // eslint-disable-line
import type { TGalleryProps } from './interface'
import baseStyle, { getNavigationButtonStyle } from './styles'

const StyledGallery = styled.div(() => [baseStyle])

const Gallery = (props: TGalleryProps) => {
  const { color, slides, children, ...rest } = props
  const showNavigation = slides && slides?.length > 1
  return (
    <StyledGallery {...rest}>
      {showNavigation && (
        <div
          className="button-prev button-disabled"
          tw="cursor-pointer rounded-full border-4 p-4 absolute left-0 z-20"
          css={getNavigationButtonStyle(color ?? 'black')}
        >
          <Icon icon="ArrowLeft" />
        </div>
      )}
      <Swiper
        cssMode
        mousewheel
        keyboard
        lazyPreloadPrevNext={1}
        modules={[Navigation]}
        navigation={{
          prevEl: '.button-prev',
          nextEl: '.button-next',
          disabledClass: 'button-disabled',
        }}
        watchOverflow
        slidesPerView={1}
        tw="relative !overflow-visible w-3/4"
      >
        {slides?.map((slide) => {
          return (
            <SwiperSlide key={slide.id}>
              <div tw="flex justify-center m-auto px-8 w-full">{slide.child}</div>
            </SwiperSlide>
          )
        })}
      </Swiper>
      {showNavigation && (
        <div
          className="button-next"
          tw="cursor-pointer rounded-full border-4 p-4 absolute right-0 z-20"
          css={getNavigationButtonStyle(color ?? 'black')}
        >
          <Icon icon="ArrowRight" />
        </div>
      )}
      {children}
    </StyledGallery>
  )
}

export default Gallery
